import React, { useEffect, useReducer, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { Box, Button, CircularProgress, Grid, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import FileSaver from "file-saver";
import { accessLogService } from "../../utils/services/access-log.service";
import AccessLogList from "../../components/access-log-list";
import { accessLogFilterInitialState } from "../../utils/filter-config";
import buildQuery from "../../utils/query-builder";
import ExportIcon from "../../globalStyles/icons/export-icon";
import DownloadIcon from "../../globalStyles/icons/download-icon";
import { isMobile } from "../../globalStyles/mobile";

function filterReducer(state, action) {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        columns: state?.columns.map((x) =>
          x?.key === action?.payload?.key ? { ...x, ...action.payload } : x
        ),
      };
    case "UPDATE_LIMIT":
      return { ...state, limit: action.payload };
    default:
      return state;
  }
}

const AcessLog = () => {
  const [accessLogData, setAccessLogData] = useState([]);
  const [viewMode, setViewMode] = useState("list");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [dataCount, setDataCount] = useState(rowsPerPage);
  const [loading, setLoading] = useState(false);
  const [filterData, dispatch] = useReducer(
    filterReducer,
    accessLogFilterInitialState
  );
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme?.palette?.primary?.main || defaultColor;
  const text_color = theme?.palette?.text?.primary || "#FFF";
  const clientId = localStorage.getItem("client_id");

  const fetchAccessLog = async () => {
    setLoading(true);
    try {
      const response = await accessLogService.fetch(
        rowsPerPage,
        page * rowsPerPage,
        clientId,
        buildQuery(filterData, page)
      );
      setAccessLogData(response.data);
      setDataCount(response.total);
    } catch (error) {
      console.error("Fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAccessLog();
  }, [page, rowsPerPage, filterData]);

  const handleFilterChange = (newFilter) => {
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };

  const handleExport = async () => {
    setLoading(true);
    try {
      const response = await accessLogService.exportAccessLog(
        clientId,
        buildQuery(filterData, page)
      );
      let sliceSize = 1024;
      let byteCharacters = atob(response.file);
      let bytesLength = byteCharacters.length;
      let slicesCount = Math.ceil(bytesLength / sliceSize);
      let byteArrays = new Array(slicesCount);
      for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        let begin = sliceIndex * sliceSize;
        let end = Math.min(begin + sliceSize, bytesLength);
        let bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      let blob = new Blob(byteArrays, { type: response.contentType });
      FileSaver.saveAs(new Blob([blob], {}), response.filename);
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DashboardContainer
        filterButton={false}
        hideUploadButton
        header={"Access Log"}
        hideAddButton={true}
        setViewMode={setViewMode}
        hideFilterClient={true}
        onClickRefresh={() => fetchAccessLog()}
        headerButtons={
          isMobile() ? (
            <IconButton onClick={handleExport}>
              <DownloadIcon fill={primary_color} />
            </IconButton>
          ) : (
            <Grid>
              <Button
                size="small"
                style={{ textTransform: "none" }}
                variant="contained"
                color="primary"
                onClick={handleExport}
              >
                <ExportIcon fill={"#ffff"} />
                <Typography
                  fontSize="14px"
                  fontWeight={500}
                  sx={{ color: text_color, marginLeft: 1 }}
                  fontFamily={"poppins"}
                >
                  Export
                </Typography>
              </Button>
            </Grid>
          )
        }
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <AccessLogList
            dataCount={dataCount}
            currentPage={page}
            itemsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setPage={setPage}
            data={accessLogData}
            viewMode={viewMode}
            filterData={filterData}
            onChangeFilter={handleFilterChange}
          />
        )}
      </DashboardContainer>
    </>
  );
};

export default AcessLog;
